import { render } from "./PixelsInput.vue?vue&type=template&id=92b8b1d2&scoped=true"
import script from "./PixelsInput.vue?vue&type=script&lang=js"
export * from "./PixelsInput.vue?vue&type=script&lang=js"

import "./PixelsInput.vue?vue&type=style&index=0&id=92b8b1d2&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92b8b1d2"]])

export default __exports__